import { LOCALHOST_CHAIN_ID } from '@towns-protocol/web3';
// w/ pimlico alto bundler it doesn't estimate high enough, why? quick fix
export function doubleGasIfLocalAnvil(chainId, gas) {
    if (chainId === LOCALHOST_CHAIN_ID) {
        return gas * 2n;
    }
    return gas;
}
